import classcat from "classcat";
import React from "react";

import {
  Button,
  ConfirmationModal,
  IconLinkRemove,
} from "@touchtech/web-baselayer-ui";

import css from "./SelectScannerModal.module.css";
import useManageSelectScannerModal from "./hooks/useManageSelectScannerModal";

type Props = {
  onClose: () => void;
};
function SelectScannerModal({ onClose }: Props) {
  const { handleSelectScanner, handleDisconnectScanner, scannerName, t } =
    useManageSelectScannerModal();

  const isScannerConnected = !!scannerName;

  return (
    <ConfirmationModal
      isOpen
      onClose={onClose}
      buttonsRight={[
        <div key="skip" className={css.buttonBox}>
          <Button
            width="full"
            sizing="lg"
            variant="secondary"
            onClick={onClose}
          >
            {t("Skip")}
          </Button>
        </div>,
        <div key="continue" className={css.buttonBox}>
          <Button
            width="full"
            sizing="lg"
            variant="primary"
            onClick={onClose}
            className={isScannerConnected ? css.primaryButton : undefined}
            state={!isScannerConnected ? "disabled" : undefined}
          >
            {t("Continue")}
          </Button>
        </div>,
      ]}
    >
      <div className={css.container}>
        <header className="text-headline-5xl">{t("Connect scanner")}</header>
        <span className="text-label-lg">
          {t(
            "Find a scanner to connect to the device. You can connect a scanner later in the staff dashboard."
          )}
        </span>
        <div className={classcat(["text-label-xl", css.scanner])}>
          {isScannerConnected ? (
            <div className={css.connectedScanner}>
              <span>
                {t(`Scanner with the name "{{scannerName}}" is connected.`, {
                  scannerName,
                })}
              </span>
              <button onClick={handleDisconnectScanner}>
                <IconLinkRemove />
              </button>
            </div>
          ) : (
            <div className={css.findScanner}>
              <button onClick={handleSelectScanner}>
                <span>{t("Click here")}</span>
              </button>
              {t("to find a scanner")}
            </div>
          )}
        </div>
      </div>
    </ConfirmationModal>
  );
}

export default SelectScannerModal;
